import axiosInstance from './axiosInstance';
import { IGateway } from '../interfaces/Gateway/IGateway.ts';

interface GetGatewaysResponse {
  items: IGateway[];
  limit: number;
  offset: number;
  total: number;
}

interface GetGatewaysParams {
  page?: number;
  per_page?: number;
  query?: string;
  ignore_case?: boolean;
  orderBy?: string;
  sortOrder?: 'asc' | 'desc';
  carehome_id?: string;
  organisation_id?: string;
  type?: 'Node' | 'Exit' | 'Charger';
  is_active?: boolean;
  unassigned?: boolean;
  assigned?: boolean;
  station_id?: string;
}

interface UpdateGatewayParams {
  carehome_id?: string;
  resident_id?: string | null;
  ble_mac: string;
  lte_imei?: string | null;
  lte_iccid?: string | null;
  lte_imsi?: string | null;
  wifi_mac?: string | null;
  serial: string;
  model: string;
  batch: string;
  label?: string | null;
  type: 'Node' | 'Exit' | 'Charger';
  password?: string | null;
  is_active?: boolean;
}

class GatewayService {
  private static instance: GatewayService;
  private constructor() {}

  public static getInstance(): GatewayService {
    if (!GatewayService.instance) {
      GatewayService.instance = new GatewayService();
    }
    return GatewayService.instance;
  }

  public async getGateway(gatewayId: string): Promise<IGateway> {
    try {
      const response = await axiosInstance.get<IGateway>(
        `/gateways/${gatewayId}`
      );
      return response.data;
    } catch (error) {
      throw new Error('Failed to fetch gateway data');
    }
  }

  public async getGateways(
    params: GetGatewaysParams
  ): Promise<GetGatewaysResponse> {
    try {
      const response = await axiosInstance.get<GetGatewaysResponse>(
        '/gateways',
        { params }
      );
      return response.data;
    } catch (error) {
      throw new Error('Failed to fetch gateways data');
    }
  }

  public async updateGateway(
    gatewayId: string,
    params: UpdateGatewayParams
  ): Promise<IGateway> {
    try {
      const response = await axiosInstance.put<IGateway>(
        `/gateways/${gatewayId}`,
        params
      );
      return response.data;
    } catch (error) {
      throw new Error('Failed to update gateway data');
    }
  }

  public async assignGatewayToResident(
    gatewayId: string,
    residentId: string
  ): Promise<void> {
    try {
      await axiosInstance.post(`/gateways/${gatewayId}/assign`, {
        resident_id: residentId,
      });
    } catch (error) {
      throw new Error('Failed to assign gateway to resident');
    }
  }

  public async deAssignGatewayFromResident(gatewayId: string): Promise<void> {
    try {
      await axiosInstance.delete(`/gateways/${gatewayId}/de_assign`);
    } catch (error) {
      throw new Error('Failed to deassign gateway from resident');
    }
  }
}

export default GatewayService.getInstance();
